import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as utils from 'core/utils';
import * as flights from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class FlightDetailsComponent extends Vue {
    @Prop()
    flight: flights.FlightModel;

    @Prop()
    bookingUrl: string;

    @Prop()
    passengerCount: number;

    @Prop()
    searchId: string;
    
    @Prop()
    gaParams: any;

    mounted() {
        (<any>this).$ga.sendPageview('/flights/search/results/details', 'Flights / Search / Results / Details', this.gaParams);

        new api.RetailRocket().flightDetailsOpened({
            flightId: this.flight.uniqueId,
            searchId: this.searchId
        });

    }

    getBookingClassLabel(bookingClass: string): string {
        return i18next.t('label_flight_class_' + bookingClass.toLowerCase());
    }

    getBaggageLabel(flightBaggage: api.FlightBaggage, isCabin: boolean, short: boolean): string {
        return utils.Baggage.getLabel(flightBaggage, isCabin, short);
    }

    getDestinationTooltip(d: api.Destination): string {
        const result = d.localizedName + '<br/>' +
            '<i class="el-icon-location"></i> ' + d.city.localizedName + ', ' +
            d.country.localizedName;

        return result;
    }

    hasBaggage(legOrSegment: flights.LegModel | flights.SegmentModel): boolean {
        return legOrSegment.baggage && (legOrSegment.baggage.pieceWeight > 0 || legOrSegment.baggage.pieces > 0);
    }

    hasBaggageCabin(legOrSegment: flights.LegModel | flights.SegmentModel): boolean {
        return legOrSegment.baggageCabin && (legOrSegment.baggageCabin.pieceWeight > 0 || legOrSegment.baggageCabin.pieces > 0);
    }

    listAirlines(): string {
        let result = '';

        this.flight.airlines.forEach(a => {
            if (result) {
                result += ', ';
            }

            result += a.name;
        });

        return result;
    }

    onFlightSubmit() {
        (<any>this).$ga.sendEvent('flights.results', 'flight.buy', 'flights.results.flight.buy', this.gaParams);
    }

    onFlightTerms() {
        this.$emit('terms', this.flight.uniqueId);

        (<any>this).$ga.sendEvent('flights.results', 'flight.terms', 'flights.results.flight.terms', this.gaParams);
    }

    getFlightRouteToParam(flight: flights.FlightModel) {
        if (flight.externalPartner
            && this.searchId
            && flight.uniqueId) {
            return {
                path: '/partner',
                query: {
                    sid: this.searchId,
                    fid: flight.uniqueId,
                    pn: flight.externalPartner.name
                }
            };
        } else {
            return this.bookingUrl;
        }
    }
}
